// extracted by mini-css-extract-plugin
export var md = "_21-4";
export var semantic = "_21-5";
export var sm = "_21-3";
export var text = "_21-6";
export var toggleInput = "_21-0";
export var toggleSwitch = "_21-1";
export var xs = "_21-2";